import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { PermissionService } from '../permission.service';

@Component({
  selector: 'app-permission-dialog',
  templateUrl: './permission-dialog.component.html',
})
export class PermissionDialogComponent {
  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private permissionService: PermissionService,
    private dialogRef: MatDialogRef<PermissionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.form = this.fb.group({
      name: ['', Validators.required],
      description: [''],
      group: [''],
    });
  }

  save() {
    if (this.form.valid) {
      this.permissionService.createPermission(this.form.value).subscribe({
        next: (res) => this.dialogRef.close(res),
        error: (err) => console.error('Failed to create permission', err),
      });
    }
  }

  close() {
    this.dialogRef.close();
  }
}
